import { api } from '@/fsd/shared/api';
import { IWarehouse } from '../../model/types/IWarehouse';

export const getWarehouses = async ({
  type,
}: {
  type?: string;
}): Promise<IWarehouse[] | undefined> => {
  try {
    let url = '/api/v1/general/user/warehouse/';

    if (type) {
      url += `?type=${type}`;
    }

    const data = await api.get<IWarehouse[]>(url.toString());

    return data;
  } catch (e) {
    console.error(e);
    return;
  }
};
